// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { CollectionConfiguration } from './base/CollectionConfigurationComponent';
import { getDefaultSlots } from '@progress/kendo-vue-common';
/**
 * @hidden
 */
var ChartPanesVue2 = {
  name: 'KendoChartPanes',
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlots = getDefaultSlots(this);
    return (
      // @ts-ignore  function children
      h(CollectionConfiguration, {
        chartKey: "panes",
        attrs: this.v3 ? undefined : {
          chartKey: "panes"
        }
      }, this.v3 ? function () {
        return [defaultSlots];
      } : [defaultSlots])
    );
  }
};
/**
 * @hidden
 */
var ChartPanes = ChartPanesVue2;
export { ChartPanes, ChartPanesVue2 };